import roleMenuService from '@/services/roleMenu.service';
import config from '@/config/prod.env';

const actions = {    
    async getByRoleIdAndMenuIds({ dispatch }, obj) {
        return await roleMenuService.getByRoleIdAndMenuIds(obj.roleId, obj.menuIds);
    },
    
    async createRoleMenuMultiple({ dispatch, commit }, obj) {
        let body = [];
        obj.menuIds.forEach(menuId => {
            body.push({
                roleId: obj.roleId, 
                menuId: menuId
            });
        });
        let res = await roleMenuService.createMultiple(body);
        if(res.isOk) {
            dispatch("alert/success", "Cập nhật dữ liệu thành công", { root: true });
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async deleteByRoleIdAndMenuIds({ dispatch }, obj) {
        return await roleMenuService.deleteByRoleIdAndMenuIds(obj.roleId, obj.menuIds);
    },
};

export const roleMenu = {
    namespaced: true,
    actions
};